import { UseQueryOptions, useQuery } from '@hooks/react-query';
import { ApiError, ApiResult } from '@models/api';

import type { AgreementSummaryResponse } from '../models';

function useRGetAgreementSummary(
  options: UseQueryOptions<ApiResult<AgreementSummaryResponse>, ApiError> & {
    loanXid?: number;
  } = {},
) {
  const { loanXid, ...resOptions } = options;

  return useQuery({
    queryKey: ['loan/agreement_summary', { loan_xid: loanXid }],
    enabled: true,
    ...resOptions,
  });
}

export default useRGetAgreementSummary;
